import { useTranslation } from "react-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";

import { useRef } from "react";

import s1 from '../../img/s1.png';
import s2 from '../../img/s2.png';
import s3 from '../../img/s3.png';
import s4 from '../../img/s4.png';
import s5 from '../../img/s5.png';
import s6 from '../../img/s6.png';

const data = [
    {
        img: s1,
        title: 'home.57',
        stage: 'home.58',
        text: 'home.59',
    },
    {
        img: s2,
        title: 'home.60',
        stage: 'home.61',
        text: 'home.62',
    },
    {
        img: s3,
        title: 'home.63',
        stage: 'home.64',
        text: 'home.65',
    },
    {
        img: s4,
        title: 'home.66',
        stage: 'home.67',
        text: 'home.68',
    },
    {
        img: s5,
        title: 'home.69',
        stage: 'home.70',
        text: 'home.71',
    },
    {
        img: s6,
        title: 'home.72',
        stage: 'home.73',
        text: 'home.74',
    },
]


function MeatOurTeam () {

    const { t } = useTranslation();

    const swiperRef = useRef(null);
      
    return(
        <>
            <div className="overflow-hidden relative max-w-[1220px] mx-[20px] xl:mx-auto mt-[80px] xl:mt-[140px]">
                <div className="flex justify-between items-center">
                    <p className="host-grotesk leading-[1.2] xl:text-[40px] text-[#382F12] text-[28px]">{t('home.56')}</p>
                    <div className="flex items-center gap-[20px]">
                        <svg className="cursor-pointer hover:scale-[0.95] transition-all" onClick={() => swiperRef.current?.slidePrev()} xmlns="http://www.w3.org/2000/svg" width="41" height="16" viewBox="0 0 41 16" fill="none">
                            <path d="M0.292893 7.29289C-0.0976295 7.68341 -0.0976296 8.31658 0.292892 8.7071L6.65685 15.0711C7.04738 15.4616 7.68054 15.4616 8.07107 15.0711C8.46159 14.6805 8.46159 14.0474 8.07107 13.6569L2.41422 8L8.07107 2.34314C8.46159 1.95262 8.46159 1.31945 8.07107 0.928929C7.68054 0.538405 7.04738 0.538405 6.65685 0.928929L0.292893 7.29289ZM41 8L41 7L1 7L1 8L1 9L41 9L41 8Z" fill="#CECABE"/>
                        </svg>
                        <svg className="cursor-pointer hover:scale-[0.95] transition-all" onClick={() => swiperRef.current?.slideNext()} xmlns="http://www.w3.org/2000/svg" width="41" height="16" viewBox="0 0 41 16" fill="none">
                            <path d="M40.7071 8.70711C41.0976 8.31658 41.0976 7.68342 40.7071 7.29289L34.3431 0.928932C33.9526 0.538408 33.3195 0.538408 32.9289 0.928932C32.5384 1.31946 32.5384 1.95262 32.9289 2.34315L38.5858 8L32.9289 13.6569C32.5384 14.0474 32.5384 14.6805 32.9289 15.0711C33.3195 15.4616 33.9526 15.4616 34.3431 15.0711L40.7071 8.70711ZM0 8V9H40V8V7H0V8Z" fill="#CECABE"/>
                        </svg>
                    </div>
                </div>
                <div className="mt-[30px] xl:mt-[40px]">
                    <Swiper
                        modules={[Autoplay]}
                        onSwiper={(swiper) => (swiperRef.current = swiper)}
                        autoplay={{ delay: 3000, disableOnInteraction: false }}
                        spaceBetween={20}
                        breakpoints={{
                        320: { slidesPerView: 1 },
                        450: { slidesPerView: 2 },
                        768: { slidesPerView: 4 },
                        1280: { slidesPerView: 4 },
                        }}
                        loop
                    >
                        {data.map((item, index) => (
                            <SwiperSlide key={index}>
                                <div className="border border-[#CECABE] rounded-[10px] h-[500px]  md:h-[444px] relative">
                                    <img src={item.img} className="w-full" alt={t(item.title)} />
                                    <h3 className="host-grotesk leading-[1.2] text-[16px] xl:text-[20px] px-[20px] pt-[20px]">{t(item.title)}</h3>
                                    <p className="px-[20px] text-[#000000B2] mt-[6px] PtRoot font-[700] text-[12px] xl:text-[14px]">{t(item.stage)}</p>
                                    <p className="px-[20px] text-[#000000B2] pb-[20px] text-[12px] xl:text-[14px] PtRoot absolute bottom-0">{t(item.text)}</p>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </div>
        </>
    );
}

export default MeatOurTeam;